import { z } from 'zod';
import { isValidCpf } from './cpf';

export const loginSchema = z.object({
  email: z.string().email('Email inválido'),
  password: z.string().min(1, 'Senha obrigatória')
});

export const registerSchema = z.object({
  name: z.string().min(3, 'Nome completo obrigatório'),
  email: z.string().email('Email inválido'),
  cpf: z.string().refine(isValidCpf, 'CPF inválido'),
  phone: z
    .string()
    .min(10, 'Telefone inválido')
    .transform((s) => s.replace(/\D/g, '')),
  password: z
    .string()
    .min(8, 'Mínimo 8 caracteres')
    .regex(/[A-Z]/, 'Precisa de ao menos 1 letra maiúscula')
    .regex(/\d/, 'Precisa de ao menos 1 número'),
  consent_terms: z.literal(true, { errorMap: () => ({ message: 'Obrigatório' }) }),
  consent_privacy: z.literal(true, { errorMap: () => ({ message: 'Obrigatório' }) })
});

export const forgotPasswordSchema = z.object({
  email: z.string().email('Email inválido'),
});

export const resetPasswordSchema = z
  .object({
    new_password: z
      .string()
      .min(8, 'Mínimo 8 caracteres')
      .regex(/[A-Z]/, 'Precisa de ao menos 1 letra maiúscula')
      .regex(/\d/, 'Precisa de ao menos 1 número'),
    confirm_password: z.string().min(1, 'Confirmação obrigatória'),
  })
  .refine((d) => d.new_password === d.confirm_password, {
    message: 'Senhas não coincidem',
    path: ['confirm_password'],
  });

export const emailChangeSchema = z.object({
  new_email: z.string().email('Email inválido'),
  // Validada só quando a conta tem senha local (o form decide exigir).
  current_password: z.string().optional(),
});

export type LoginFormData = z.infer<typeof loginSchema>;
export type RegisterFormData = z.infer<typeof registerSchema>;
export type ForgotPasswordFormData = z.infer<typeof forgotPasswordSchema>;
export type ResetPasswordFormData = z.infer<typeof resetPasswordSchema>;
